export default __webpack_public_path__ + "static/media/VIDEOREEL (Default).5f4098bd.png";